import { render, staticRenderFns } from "./LoginHistoryManage.vue?vue&type=template&id=a326b956&"
import script from "./LoginHistoryManage.vue?vue&type=script&lang=js&"
export * from "./LoginHistoryManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports